// componente para cambiar el password

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { urls } from "../../api-urls/api-urls";


// GET the language
import { LANGUAGE } from "../../config/appConf.js";

// import react translation
import { useTranslation } from "react-i18next";





export const ResetPasswdView = () => {

  // GET the react translation
  const [t] = useTranslation("global");

  // GET the params
  const { code } = useParams();


  // GET the useNavigate
  const navigate = useNavigate();


  // state definition
  const [form, setForm] = useState({ passwd1: "", passwd2: "" });
  const [controller, setController] = useState(null); // estado para cancelar la peticion
  const [state, setState] = useState({ showPassw: false, isLoading: false, dataVisi: false, msg: "", updating: false, success: false });
  const [listErr, setListErr] = useState([]);


  // funcion para validar la contraseña
  const onHandleValPasswd = (passwd1 = "", passw2 = "") => {
    // expresiones regulares
    const HasUpperCase = /[A-Z]/.test(passwd1); // true si incluye mayuscula
    const HasLowerCase = /[a-z]/.test(passwd1); // true si incluye miniscula
    const HasNumber = /[0-9]/.test(passwd1); // true si incluye un numero
    const HasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(passwd1); // true si incluye uno de estos caracteres
    const HasMinLength = passwd1.length >= 8; // true si es mayor o igual a 8

    if (!HasUpperCase || !HasLowerCase || !HasNumber || !HasSpecialChar || !HasMinLength) {
      console.log("Errorss")
      const LisErr = [
        "Al menos debe tener una letra mayúscula.",
        "Al menos debe tener una letra minuscula.",
        "Al menos debe tener un número.",
        `Al menos debe tener uno de estos caracteres: !@#$%^&*(),.?":{}|<></>`,
        "Debe tener 8 ó más caracteres."
      ];
      setListErr(LisErr);

    }

    if ((HasUpperCase && HasLowerCase && HasNumber && HasSpecialChar && HasMinLength) && (passwd1 === passw2)) {
      setListErr([]);
      return true;
    }

    if (passwd1 !== passw2) {
      setListErr(["Las contraseñas no coinciden."]);
    }

    return false;

  };


  // funcion para enviar el formulario al servidor
  const onHandleSubmit = async (event) => {
    event.preventDefault();

    if (!onHandleValPasswd(form.passwd1, form.passwd2)) {
      return;
    }

    const END_POINT = `${urls.authRoute}/new-passwd?token_recov=${code}&language=${LANGUAGE}`;

    try {
      setState((val) => ({ ...val, updating: true }));
      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });

      const data = await response.json();

      if (response.status === 200) {
        setState((val) => ({ ...val, dataVisi: false, success: true, msg: data?.msg }));
      }

      setState((val) => ({ ...val, updating: false }));

    } catch (error) {
      console.log(error);
    }
  }


  // funcion para consultar la informacion al servidor
  const fetchDataServ = async () => {
    const abortController = new AbortController();

    setController(abortController);

    const END_POINT = `${urls.authRoute}/know-token-recover?token_recov=${code}&language=${LANGUAGE}`;

    try {
      setState((val) => ({ ...val, isLoading: true }));
      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = await response.json();

      if (response.status === 200) {
        setState((val) => ({ ...val, dataVisi: true, msg: "" }));
      } else if (response.status === 400) {
        console.log(data?.msg);
        setState((val) => ({ ...val, msg: data?.msg }));
      } else if (response.status === 404) {
        setState((val) => ({ ...val, msg: data?.msg }));
      }


      setState((val) => ({ ...val, isLoading: false }));

    } catch (error) {
      console.log(error);
    }
  };


  // useEffect para traer la data del servidor
  useEffect(() => {

    fetchDataServ();

    return () => {
      if (controller) {
        controller.abort();
      }
    }

  }, []);



  return (
    <div className="reset-contan-paswd">
      {
        (state.msg && !state.success) && (
          <h4 style={{ color: "var(--danger-color)" }}>{state.msg}</h4>
        )
      }

      {
        state.success && (
          <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            <h4>{state.msg}</h4>
            <button className="btn-success" onClick={() => navigate("/")}>{t("HomeViewComp.regr_login")}</button>
          </div>
        )
      }

      {
        state.dataVisi && (
          <form onSubmit={onHandleSubmit} className="card-reset fade-animation">
            <h4>{t("HomeViewComp.cambiar_passw")}</h4>

            <p className="txt-muted">{t("HomeViewComp.msg_seguridad")}</p>

            <label style={{ cursor: "auto", fontWeight: "bold", fontSize: "16px" }} className="label-pwd" htmlFor="passwd1">Enter new password</label>

            <div className="con-inp-lst">
              <input
                style={{ marginTop: "3px", marginBottom: "5px" }}
                className="input-control-text"
                type={state.showPassw ? "text" : "password"}
                name="passwd1"
                id="passwd1"
                value={form.passwd1}
                onChange={({ target }) => setForm((val) => ({ ...val, passwd1: target.value }))} />
              <button type="button" onClick={() => setState((val) => ({ ...val, showPassw: !state.showPassw }))}>
                {
                  state.showPassw ?
                    (<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="var(--first-color)" className="bi bi-eye-slash-fill" viewBox="0 0 16 16">
                      <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                      <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                    </svg>)
                    :
                    (<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="var(--first-color)" className="bi bi-eye-fill" viewBox="0 0 16 16">
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                    </svg>)
                }
              </button>
            </div>

            {
              listErr.length > 0 && (
                <div style={{ padding: "5px 5px 5px 25px" }}>
                  <ul className="list-err">
                    {
                      listErr.map((er, index) => (
                        <li key={index}>{er}</li>
                      ))
                    }
                  </ul>
                </div>
              )
            }

            <label style={{ cursor: "auto", fontWeight: "bold", fontSize: "16px" }} className="label-pwd" htmlFor="passwd2">{t("HomeViewComp.conf_passw")}</label>
            <input
              style={{ marginTop: "3px" }}
              className="input-control-text"
              type={state.showPassw ? "text" : "password"}
              name="passwd2"
              id="passwd2"
              value={form.passwd2}
              onChange={({ target }) => setForm((val) => ({ ...val, passwd2: target.value }))} />

            <button
              type={((!form.passwd1.length || !form.passwd2.length) || state.updating) ? "button" : "submit"}
              className={`btn-send-inst ${((!form.passwd1.length || !form.passwd2.length) || state.updating) ? "disabled-class" : ""}`}>{t("HomeViewComp.guard_contr")}</button>
          </form>
        )
      }
    </div>
  );
};